/**
 * lib/views/javascripts/proto-relay-float.js — the entry module for the
 * Proto host's floating Relay window (lib/views/htmls/proto/relay-float.ejs;
 * ADR 0082 D3).
 *
 * Contents: view
 * Ontology: Code object M33C-1025 (immutable ref — assigned once, never edit)
 * Team: J. Brant Arseneau & the Mach33 Agents.
 */

import { bindRelayFloat } from './proto/relay-float.js';

// ── Start ────────────────────────────────────────────────────────────────
bindRelayFloat();
